import { DirectDebitNavbar, PoweredBy, hostedPageStyle } from "./DirectDebitChrome";

const haloStyle = {
  width: 110,
  height: 110,
  borderRadius: "50%",
  background: "#F1FFF8",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const badgeStyle = {
  width: 72,
  height: 72,
  borderRadius: "50%",
  background: "#E0FFF0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const copyStyle = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 4,
};

const titleStyle = {
  margin: 0,
  width: "100%",
  textAlign: "center",
  fontSize: 20,
  fontWeight: 700,
  lineHeight: "30px",
  color: "#151D2D",
};

const subtitleStyle = {
  margin: 0,
  width: "100%",
  textAlign: "center",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  color: "#505662",
};

const methodTextStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 2,
};

const numberRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
  height: 20,
};

const numberStyle = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  color: "#1E2635",
};

const dotGroupStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
};

const dotStyle = {
  width: 5,
  height: 5,
  borderRadius: "50%",
  background: "#1E2635",
};

const bankNameStyle = {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  color: "#9EA1A8",
};

const linkedStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  height: 18,
  padding: "0 7px",
  border: "1px solid #80BC9D",
  borderRadius: 999,
  background: "rgba(1, 121, 59, 0.05)",
  boxSizing: "border-box",
  fontSize: 12,
  fontWeight: 500,
  lineHeight: "16px",
  color: "#01793B",
  flexShrink: 0,
};

const logoStyle = {
  width: 50,
  height: 14.6,
  display: "block",
  objectFit: "contain",
  flexShrink: 0,
};

const layoutCss = `
  .dd-success-main {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    padding: 24px 16px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    box-sizing: border-box;
  }
  .dd-success-card {
    width: 100%;
    background: #FFFFFF;
    border-radius: 24px;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
  }
  .dd-success-method {
    width: 100%;
    border: 1px solid #E1E3E4;
    border-radius: 16px;
    padding: 15px 15px 15px 23px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "logo text"
      "linked linked";
    column-gap: 16px;
    row-gap: 16px;
    align-items: center;
    justify-items: start;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
  }
  .dd-success-logo { grid-area: logo; }
  .dd-success-method-text { grid-area: text; }
  .dd-success-linked { grid-area: linked; }
  @media (min-width: 1024px) {
    .dd-success-main {
      flex: 1 0 auto;
      justify-content: center;
      justify-content: safe center;
      max-width: none;
      min-height: calc(100vh - 64px);
      padding: 32px 16px;
    }
    .dd-success-card {
      max-width: 516px;
      padding: 32px;
    }
    .dd-success-method {
      grid-template-columns: auto 1fr auto;
      grid-template-areas: "logo text linked";
      padding: 15px 23px;
      row-gap: 0;
    }
  }
`;

function DotGroup() {
  return (
    <span style={dotGroupStyle}>
      {Array.from({ length: 4 }, (_, index) => (
        <span key={index} style={dotStyle} />
      ))}
    </span>
  );
}

function lastFour(maskedCard) {
  const last = (String(maskedCard || "").match(/\d+$/) || [""])[0].slice(-4);
  return last.length === 4 ? last : null;
}

function CardNumber({ last }) {
  if (!last) return null;

  return (
    <div style={numberRowStyle}>
      <DotGroup />
      <DotGroup />
      <DotGroup />
      <span style={numberStyle}>{last}</span>
    </div>
  );
}

export default function BindingSuccess({ maskedCard, brandName, logoUrl }) {
  const last = lastFour(maskedCard);

  return (
    <div style={hostedPageStyle}>
      <style>{layoutCss}</style>
      <DirectDebitNavbar brandName={brandName} logoUrl={logoUrl} />

      <main className="dd-success-main">
        <section className="dd-success-card">
          <div style={haloStyle}>
            <div style={badgeStyle}>
              <img src="/assets/images/direct-debit/success-check.svg" alt="" width={48} height={48} style={{ width: 48, height: 48, display: "block" }} />
            </div>
          </div>

          <div style={copyStyle}>
            <h1 style={titleStyle}>Payment Method Connected!</h1>
            <p style={subtitleStyle}>
              Your card has been successfully linked and is ready for you to use for Direct Debit payment.
            </p>
          </div>

          <div className="dd-success-method">
            <img
              className="dd-success-logo"
              src="/assets/images/direct-debit/mandiri.png"
              alt="Mandiri"
              width={50}
              height={15}
              style={logoStyle}
            />
            <div className="dd-success-method-text" style={methodTextStyle}>
              <CardNumber last={last} />
              <span style={bankNameStyle}>Bank Mandiri</span>
            </div>
            <span className="dd-success-linked" style={linkedStyle}>
              <img src="/assets/images/direct-debit/linked-check.svg" alt="" width={10} height={10} style={{ width: 10, height: 10, display: "block" }} />
              Linked
            </span>
          </div>
        </section>

        <PoweredBy />
      </main>
    </div>
  );
}
